export default class AdminLabRequests {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminLabRequestsEndpoint, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabRequestsEndpoint}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabRequestsEndpoint}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminLabRequestsEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminLabRequestsEndpoint}/${id}`, payload, {})
  }

  cancel(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminLabRequestsEndpoint}/${id}/cancel`, {})
  }
}
